import { CommonModule, DatePipe, formatDate } from '@angular/common';
import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { finalize } from 'rxjs';
import { FormBuilder, ReactiveFormsModule } from '@angular/forms';
import { Router } from '@angular/router';
import { MatBadgeModule } from '@angular/material/badge';
import { MatButtonModule } from '@angular/material/button';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatDialog, MatDialogModule } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatMenuModule, MatMenuTrigger } from '@angular/material/menu';
import { MatNativeDateModule, MAT_DATE_LOCALE, DateAdapter } from '@angular/material/core';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatSelectModule } from '@angular/material/select';
import { MatSort, MatSortModule } from '@angular/material/sort';
import { MatTableDataSource, MatTableModule } from '@angular/material/table';
import { MatTooltipModule } from '@angular/material/tooltip';
import { SelectionModel } from '@angular/cdk/collections';
import { environment } from '../../../../environments/environment';
import { HeaderComponent } from '../../../shared/components/header/header.component';
import { EmptyListComponent } from '../../../shared/components/empty-list/empty-list.component';
import { LoadingBoxDefaultListComponent } from '../../../shared/components/loading-box-default-list/loading-box-default-list.component';
import { SelectPesquisavelComponent } from '../../../shared/components/select-pesquisavel/select-pesquisavel.component';
import { AlertService, AlertType } from '../../../shared/services/alert.service';
import { AuthService } from '../../../shared/services/apis/usuario/auth.service';
import { CustomDateAdapter } from '../../../shared/services/custom-date-adapter';
import { MaskService } from '../../../shared/services/mask.service';
import { UtilService } from '../../../shared/services/util.service';
import { Empresa } from '../../../shared/services/models/usuario/empresa.model';
import { PessoaLookupService } from '../../../shared/services/apis/pessoa/pessoa-lookup.service';
import { ListPessoaIdsRequest } from '../../../shared/services/requests/pessoa/list-pessoa-ids-request';
import { ModuloEnum } from '../../../shared/enums/usuario/modulo.enum';
import { FuncionalidadeEnum } from '../../../shared/enums/usuario/funcionalidade.enum';
import { OrigemNFeEntradaEnum } from '../../../shared/enums/repo-dfe/origem-nfe-entrada.enum';
import { StatusNFeEntradaEnum } from '../../../shared/enums/repo-dfe/status-nfe-entrada.enum';
import { TipoIntegracaoEnum, TipoIntegracaoIndicador } from '../../../shared/enums/repo-dfe/tipo-integracao.enum';
import { AcaoNotaFiscalEntradaEnum } from '../../../shared/enums/suprimentos/acao-nota-fiscal-entrada.enum';
import { PeriodoNotaFiscalEntradaEnum } from '../../../shared/enums/suprimentos/periodo-nota-fiscal-entrada.enum';
import { ResumoNotaFiscalEntradaEnum } from '../../../shared/enums/suprimentos/resumo-nota-fiscal-entrada.enum';
import { NotaFiscalEntradaListStruct } from '../../../shared/services/structs/repo-dfe/nota-fiscal-entrada-list.struct';
import { NotaFiscalEntradaResumoStruct } from '../../../shared/services/structs/repo-dfe/nota-fiscal-entrada-resumo.struct';
import { NotaFiscalEntradaLookupStruct } from '../../../shared/services/structs/repo-dfe/nota-fiscal-entrada-lookup.struct';
import { AcaoNotaFiscalEntradaStruct } from '../../../shared/services/structs/repo-dfe/acao-nota-fiscal-entrada.struct';
import { acoesNotaFiscalEntrada } from '../../../shared/helpers/nota-fiscal-entrada-acoes.helper';
import {
  classeBadgeManifestacao,
  classeBadgeStatusNFeEntrada,
  descricaoDisponibilidadeDocumentoSefaz,
  iconeOrigemNFeEntrada,
  iconeStatusNFeEntrada,
  isStatusParcial,
  pedidosComDivergencia,
  rotuloDisponibilidadeDocumentoSefaz,
  rotuloManifestacao,
  tooltipPedidosComDivergencia,
} from '../../../shared/helpers/nota-fiscal-entrada-status.helper';
import { AbntPipe } from '../../../shared/pipes/abnt.pipe';
import { CpfCnpjPipe } from '../../../shared/pipes/cpf-cnpj.pipe';
import { ImportarXmlNotaFiscalEntradaDialogComponent } from './dialogs/importar-xml-nota-fiscal-entrada-dialog/importar-xml-nota-fiscal-entrada-dialog.component';
import {
  ExtracaoDadosData,
  ExtracaoDadosModalComponent,
  FiltroExtracao,
} from '../../../shared/components/extracao-dados-modal/extracao-dados-modal.component';
import { OrigemPedidoExportacaoEnum } from '../../../shared/enums/batch-extracao-dados/origem-pedido-exportacao.enum';
import { TipoExtracaoEnum } from '../../../shared/enums/batch-extracao-dados/tipo-extracao.enum';
import { TagNFeEntradaService } from '../../../shared/services/apis/repo-dfe/tag-nfe-entrada.service';
import { TagNFeEntrada } from '../../../shared/services/models/repo-dfe/tag-nfe-entrada.model';
import { AlterarTagsNotaFiscalEntradaDialogComponent } from './dialogs/alterar-tags-nota-fiscal-entrada-dialog/alterar-tags-nota-fiscal-entrada-dialog.component';
import { AlterarTagsNotaFiscalEntradaDialogData } from './dialogs/alterar-tags-nota-fiscal-entrada-dialog/alterar-tags-nota-fiscal-entrada-dialog-data';
import { ConfirmModalComponent } from '../../../shared/components/confirm-modal/confirm-modal.component';
import { NFeEntradaService } from '../../../shared/services/apis/repo-dfe/nfe-entrada.service';
import { NotaFiscalEntradaService } from '../../../shared/services/apis/orquestrador-compras/nota-fiscal-entrada.service';
import { PermissaoEnum } from '../../../shared/enums/usuario/permissao.enum';
import { NFeEntradaEstoqueExcluirRequest } from '../../../shared/services/requests/orquestrador-compras/nfe-entrada-estoque-excluir.request';
import { ExcluirEstoqueNotaFiscalEntradaDialogComponent } from './dialogs/excluir-estoque-nota-fiscal-entrada-dialog/excluir-estoque-nota-fiscal-entrada-dialog.component';
import { ExcluirEstoqueNotaFiscalEntradaDialogData } from './dialogs/excluir-estoque-nota-fiscal-entrada-dialog/excluir-estoque-nota-fiscal-entrada-dialog-data';
import { NFeEntradaFinanceiroExcluirRequest } from '../../../shared/services/requests/orquestrador-compras/nfe-entrada-financeiro-excluir.request';
import { ExcluirFinanceiroNotaFiscalEntradaDialogComponent } from './dialogs/excluir-financeiro-nota-fiscal-entrada-dialog/excluir-financeiro-nota-fiscal-entrada-dialog.component';
import { NFeEntradaReabrirRequest } from '../../../shared/services/requests/orquestrador-compras/nfe-entrada-reabrir.request';
import { ReabrirNotaFiscalEntradaDialogComponent } from './dialogs/reabrir-nota-fiscal-entrada-dialog/reabrir-nota-fiscal-entrada-dialog.component';
import { ReabrirNotaFiscalEntradaDialogData } from './dialogs/reabrir-nota-fiscal-entrada-dialog/reabrir-nota-fiscal-entrada-dialog-data';
import { HistoricoNotaFiscalEntradaDialogComponent } from './dialogs/historico-nota-fiscal-entrada-dialog/historico-nota-fiscal-entrada-dialog.component';
import { HistoricoNotaFiscalEntradaDialogData } from './dialogs/historico-nota-fiscal-entrada-dialog/historico-nota-fiscal-entrada-dialog-data';
import { NotaFiscalEntradaAssociacaoDialogComponent } from '@shared/components/nota-fiscal-entrada-associacao-dialog/nota-fiscal-entrada-associacao-dialog.component';
import { NotaFiscalEntradaAssociacaoDialogData } from '@shared/components/nota-fiscal-entrada-associacao-dialog/nota-fiscal-entrada-associacao-dialog-data';
import { OrigemAssociacaoItensNFeEntradaEnum } from '../../../shared/enums/suprimentos/origem-associacao-itens-nfe-entrada.enum';
import { OrigemImportacaoXmlNFeEntradaEnum } from '../../../shared/enums/suprimentos/origem-importacao-xml-nfe-entrada.enum';
import { ImportarXmlNotaFiscalEntradaDialogData } from './dialogs/importar-xml-nota-fiscal-entrada-dialog/importar-xml-nota-fiscal-entrada-dialog-data';
import { RegraCorrespondenciaProdutoNFeEntradaEnum } from '@shared/enums/suprimentos/regra-correspondencia-produto-nfe-entrada.enum';
import { FormacaoPrecosNotaFiscalEntradaDialogComponent } from './dialogs/formacao-precos-nota-fiscal-entrada-dialog/formacao-precos-nota-fiscal-entrada-dialog.component';
import { FormacaoPrecosNotaFiscalEntradaDialogData } from './dialogs/formacao-precos-nota-fiscal-entrada-dialog/formacao-precos-nota-fiscal-entrada-dialog-data';
import { ManifestarNotaFiscalEntradaDialogComponent } from './dialogs/manifestar-nota-fiscal-entrada-dialog/manifestar-nota-fiscal-entrada-dialog.component';
import { ManifestarNotaFiscalEntradaDialogData } from './dialogs/manifestar-nota-fiscal-entrada-dialog/manifestar-nota-fiscal-entrada-dialog-data';
import { ManifestarNotaFiscalEntradaDialogResult } from './dialogs/manifestar-nota-fiscal-entrada-dialog/manifestar-nota-fiscal-entrada-dialog-result';
import { TipoEventoNFeEnum } from '@shared/enums/dfe/tipo-evento-nfe.enum';
import { ModeloDocumentoEnum } from '@shared/enums/dfe/modelo-documento.enum';
import { OrigemDocumentoFiscalRecebidoEnum } from '@shared/enums/repo-dfe/origem-documento-fiscal-recebido.enum';
import { EVENTOS_MANIFESTACAO_NFE } from '@shared/helpers/manifestacao-nfe.helper';
import { PostManifestacaoService } from '@shared/services/apis/orquestrador-dfe/post-manifestacao.service';
import { PostManifestacaoRequest } from '@shared/services/requests/orquestrador-dfe/post-manifestacao.request';
import { ConsultaChaveNFeService } from '@shared/services/apis/orquestrador-dfe/consulta-chave-nfe.service';
import { ConsultaChaveNFeRequest } from '@shared/services/requests/orquestrador-dfe/consulta-chave-nfe.request';
import { DanfeService } from '@shared/services/apis/report/danfe.service';
import { GerarPdfPorXmlRequest } from '@shared/services/requests/report/gerar-pdf-por-xml.request';
import { ReturnStruct } from '@shared/services/structs/return.struct';

interface EtapaPedidoBadgeView {
  key: string;
  nome: string;
  cor: string;
  icone: string;
  tooltip: string;
}

@Component({
  selector: 'app-nota-fiscal-entrada-lista',
  standalone: true,
  imports: [
    CommonModule,
    ReactiveFormsModule,
    HeaderComponent,
    MatFormFieldModule,
    MatInputModule,
    MatButtonModule,
    MatIconModule,
    MatMenuModule,
    MatCheckboxModule,
    MatSelectModule,
    MatSortModule,
    MatTableModule,
    MatProgressSpinnerModule,
    MatTooltipModule,
    MatBadgeModule,
    MatDatepickerModule,
    MatNativeDateModule,
    MatDialogModule,
    EmptyListComponent,
    LoadingBoxDefaultListComponent,
    SelectPesquisavelComponent,
    DatePipe,
    AbntPipe,
    CpfCnpjPipe,
  ],
  providers: [
    { provide: MAT_DATE_LOCALE, useValue: 'pt-BR' },
    { provide: DateAdapter, useClass: CustomDateAdapter },
  ],
  templateUrl: './nota-fiscal-entrada-lista.component.html',
  styleUrls: ['./nota-fiscal-entrada-lista.component.css'],
})
export class NotaFiscalEntradaListaComponent implements OnInit, OnDestroy {
  readonly moduloEnum = ModuloEnum.Suprimentos;
  readonly funcionalidadeEnum = FuncionalidadeEnum.Suprimentos_NotasFiscaisEntrada;
  readonly origemEnum = OrigemNFeEntradaEnum;
  readonly statusEnum = StatusNFeEntradaEnum;
  readonly periodoEnum = PeriodoNotaFiscalEntradaEnum;
  readonly urlFornecedor = environment.urlApiPessoa + 'Lookup/listPessoaSelect';
  readonly displayedColumns = [
    'select',
    'nota',
    'emissao',
    'lancamento',
    'fornecedor',
    'destinatario',
    'valor',
    'origem',
    'manifestacao',
    'integracoes',
    'status',
    'acoes',
  ];
  readonly selection = new SelectionModel<NotaFiscalEntradaListStruct>(true, []);
  readonly dataSource = new MatTableDataSource<NotaFiscalEntradaListStruct>();
  readonly model = this.formBuilder.group({
    pesquisa: [''],
    status: [[] as number[]],
    origem: [[] as number[]],
    fornecedor: [[] as number[]],
    tags: [[] as number[]],
    destinatario: [[] as number[]],
    dataDe: [null as Date | null],
    dataAte: [null as Date | null],
    resumoFiltro: [ResumoNotaFiscalEntradaEnum.Todos],
    periodoSelecionado: [PeriodoNotaFiscalEntradaEnum.DoMes],
  });
  /** Cards indicadores. Todos nasce selecionado e nunca fica nenhum card ativo. */
  readonly opcoesResumo = [
    {
      resumo: ResumoNotaFiscalEntradaEnum.Todos,
      rotulo: 'Todas',
      cor: 'card-filtro-cinza',
      subtexto: 'todas as notas do período',
    },
    {
      resumo: ResumoNotaFiscalEntradaEnum.CapturadasHoje,
      rotulo: 'Capturadas',
      cor: 'card-filtro-azul',
      subtexto: 'capturadas via SEFAZ',
    },
    {
      resumo: ResumoNotaFiscalEntradaEnum.EmLancamento,
      rotulo: 'Em lançamento',
      cor: 'card-filtro-amarelo',
      subtexto: 'aguardando lançamento',
    },
    {
      resumo: ResumoNotaFiscalEntradaEnum.ComDivergencia,
      rotulo: 'Com divergência',
      cor: 'card-filtro-vermelho',
      subtexto: 'divergência pendente a resolver',
    },
    {
      resumo: ResumoNotaFiscalEntradaEnum.LancadasMes,
      rotulo: 'Lançadas',
      cor: 'card-filtro-verde',
      subtexto: 'notas lançadas',
    },
  ];
  readonly opcoesPeriodo = [
    { periodo: PeriodoNotaFiscalEntradaEnum.Hoje, rotulo: 'hoje' },
    { periodo: PeriodoNotaFiscalEntradaEnum.DaSemana, rotulo: 'desta semana' },
    { periodo: PeriodoNotaFiscalEntradaEnum.DoMes, rotulo: 'do mês' },
    { periodo: PeriodoNotaFiscalEntradaEnum.Ultimos30Dias, rotulo: 'últimos 30 dias' },
    { periodo: PeriodoNotaFiscalEntradaEnum.DoIntervalo, rotulo: 'do intervalo' },
  ];

  resumo = new NotaFiscalEntradaResumoStruct();
  listaStatus: NotaFiscalEntradaLookupStruct[] = [];
  listaOrigem: NotaFiscalEntradaLookupStruct[] = [];
  listaTags: TagNFeEntrada[] = [];
  /** Empresas do grupo, para o filtro Destinatário - mesmo padrão do painel de notas recebidas, sem chamada de API. */
  listaEmpresas: Empresa[] = [];
  isSingleCompanyView = false;
  fornecedores = new Map<number, string>();
  acoesLinha: AcaoNotaFiscalEntradaStruct[] = [];
  isLoading = false;
  /** Nota com ação em andamento: o spinner fica no botão de ações da linha, não no "Ver mais" da listagem. */
  idNFeEntradaEmAcao: number | null = null;
  ultimaPagina = false;
  fullListSize = 0;
  paginaAtual = 0;
  isMobileDrawerOpen = false;
  podeLancar = false;
  podeExcluirEstoque = false;
  podeExcluirFinanceiro = false;
  podeManifestar = false;

  @ViewChild(MatSort) set matSort(sort: MatSort) {
    this.dataSource.sort = sort;
    this.dataSource.sortingDataAccessor = (row, property): string | number =>
      this.getSortValue(row, property);
  }

  constructor(
    private formBuilder: FormBuilder,
    private router: Router,
    private nfeEntradaService: NFeEntradaService,
    private notaFiscalEntradaService: NotaFiscalEntradaService,
    private pessoaLookupService: PessoaLookupService,
    private tagNFeEntradaService: TagNFeEntradaService,
    private alertService: AlertService,
    private authService: AuthService,
    private utilService: UtilService,
    private postManifestacaoService: PostManifestacaoService,
    private consultaChaveNFeService: ConsultaChaveNFeService,
    private danfeService: DanfeService,
    private dialog: MatDialog
  ) {}

  ngOnInit(): void {
    const permissoes = this.authService.getUserInfos()?.listaPermissoes ?? [];
    // Lançar estoque e financeiro vale para quem pode inserir a nota; excluir cada um tem permissão própria.
    this.podeLancar = permissoes.includes(PermissaoEnum.Suprimentos_NotasFiscaisEntrada_Inserir);
    this.podeExcluirEstoque = permissoes.includes(PermissaoEnum.Suprimentos_NotasFiscaisEntrada_ExcluirEstoque);
    this.podeExcluirFinanceiro = permissoes.includes(PermissaoEnum.Suprimentos_NotasFiscaisEntrada_ExcluirFinanceiro);
    // Mesmas permissões exigidas pelo OrquestradorDFe para manifestar e consultar a NF-e na SEFAZ.
    this.podeManifestar = permissoes.includes(PermissaoEnum.NotasFiscais_PainelNotasRecebidas_Detalhes)
      || permissoes.includes(PermissaoEnum.Suprimentos_NotasFiscaisEntrada_Alterar);
    this.carregarEmpresas();
    this.carregarTags();
    this.restaurarFiltros();
    this.pesquisar(true);
  }

  ngOnDestroy(): void {
    this.utilService.salvarFiltro(this.moduloEnum, this.funcionalidadeEnum, this.model, [
      '/suprimentos/nota-fiscal-entrada/documento',
    ]);
  }

  /** resumoFiltro/periodoSelecionado vivem no form só para entrar na persistência de filtros do padrão de UtilService.salvarFiltro. */
  get resumoFiltro(): ResumoNotaFiscalEntradaEnum {
    return this.model.get('resumoFiltro')!.value ?? ResumoNotaFiscalEntradaEnum.Todos;
  }
  get periodoSelecionado(): PeriodoNotaFiscalEntradaEnum {
    return this.model.get('periodoSelecionado')!.value ?? PeriodoNotaFiscalEntradaEnum.DoMes;
  }

  get periodoLabel(): string {
    return this.opcoesPeriodo.find(x => x.periodo === this.periodoSelecionado)?.rotulo ?? '';
  }

  get opcaoResumoAtual() {
    return this.opcoesResumo.find(x => x.resumo === this.resumoFiltro) ?? this.opcoesResumo[0];
  }

  get qtdFiltrosAvancados(): number {
    const value = this.model.getRawValue();
    return (
      (value.status?.length ? 1 : 0) +
      (value.origem?.length ? 1 : 0) +
      (value.fornecedor?.length ? 1 : 0) +
      (value.tags?.length ? 1 : 0) +
      (!this.isSingleCompanyView && value.destinatario?.length ? 1 : 0)
    );
  }

  /** Mesma regra do painel de notas recebidas: com uma só empresa no grupo, o filtro nasce travado. */
  private carregarEmpresas(): void {
    const userInfo = this.authService.getUserInfos();
    const empresaAtual = userInfo.listaEmpresa?.find(x => x.idEmpresa === userInfo.idEmpresa);

    if (!userInfo.listaEmpresasDoGrupo?.length) {
      this.isSingleCompanyView = true;
      this.listaEmpresas = empresaAtual ? [empresaAtual] : [];
    } else if (!userInfo.empresaPrincipalGrupo || userInfo.listaEmpresasDoGrupo.length === 1) {
      this.isSingleCompanyView = true;
      this.listaEmpresas = userInfo.listaEmpresasDoGrupo.filter(x => x.idEmpresa === userInfo.idEmpresa);
    } else {
      this.isSingleCompanyView = false;
      this.listaEmpresas = userInfo.listaEmpresasDoGrupo;
      return;
    }

    this.model.get('destinatario')?.setValue(this.listaEmpresas[0] ? [this.listaEmpresas[0].idEmpresa] : []);
    this.model.get('destinatario')?.disable();
  }

  private restaurarFiltros(): void {
    const filtroSalvo = this.utilService.obterFiltro(this.moduloEnum, this.funcionalidadeEnum);
    if (!filtroSalvo) return;
    this.model.patchValue(filtroSalvo);
    // carregarEmpresas() já rodou e travou o destinatário correto - o filtro salvo não pode sobrescrever isso.
    if (this.isSingleCompanyView)
      this.model
        .get('destinatario')
        ?.setValue(this.listaEmpresas[0] ? [this.listaEmpresas[0].idEmpresa] : []);
  }

  private carregarTags(): void {
    this.tagNFeEntradaService.getAll('', 1, 1000).subscribe(response => {
      if (!response.isError) this.listaTags = response.listaTags || [];
    });
  }

  pesquisar(novaBusca: boolean): void {
    if (this.isLoading) return;
    if (novaBusca) {
      this.paginaAtual = 0;
      this.ultimaPagina = false;
      this.selection.clear();
      this.dataSource.data = [];
    }
    this.isLoading = true;
    const value = this.model.getRawValue();
    const { dataDe, dataAte } = this.getPeriodo();
    const listarNotas = (listIdPessoaEmitentePesquisa: number[] | null): void => {
      const request = {
        listIdEmpresa: value.destinatario?.length ? value.destinatario : null,
        // Dia local sem fuso: o JSON de um Date sairia em UTC ("...Z") e a API monta a faixa pelo fuso da empresa.
        dataDe: formatDate(dataDe, 'yyyy-MM-dd', 'pt-BR'),
        dataAte: formatDate(dataAte, 'yyyy-MM-dd', 'pt-BR'),
        pesquisar: value.pesquisa || null,
        listIdStatusNFeEntrada: value.status?.length ? value.status : null,
        listIdOrigemNFeEntrada: value.origem?.length ? value.origem : null,
        listIdPessoaEmitente: value.fornecedor?.length ? value.fornecedor : null,
        listIdPessoaEmitentePesquisa,
        listIdTagNFeEntrada: value.tags?.length ? value.tags : null,
        comDivergencia: null,
        idResumoFiltro: this.resumoFiltro,
      };
      this.notaFiscalEntradaService.listar(request, this.paginaAtual).subscribe({
        next: response => {
          this.isLoading = false;
          if (response.isError) {
            this.alertService.show('Aviso', response.errorDescription, AlertType.warning);
            return;
          }
          this.resumo = response.resumo || new NotaFiscalEntradaResumoStruct();
          this.listaStatus = response.listaStatus || [];
          this.listaOrigem = response.listaOrigem || [];
          this.dataSource.data = [...this.dataSource.data, ...(response.list || [])];
          this.fullListSize = response.fullListSize;
          this.ultimaPagina = this.dataSource.data.length >= response.fullListSize;
          this.carregarFornecedores(response.list || []);
        },
        error: () => {
          this.isLoading = false;
        },
      });
    };

    const pesquisa = value.pesquisa?.trim();
    if (pesquisa) {
      this.pessoaLookupService.listPessoaSelect(pesquisa).subscribe({
        next: response => listarNotas(response.list?.map(pessoa => pessoa.id) ?? []),
        error: () => listarNotas([]),
      });
      return;
    }

    listarNotas(null);
  }

  aplicarFiltros(): void {
    this.pesquisar(true);
  }

  limparFiltros(): void {
    const destinatario = this.isSingleCompanyView ? this.model.get('destinatario')?.value : [];
    this.model.patchValue({
      pesquisa: '',
      status: [],
      origem: [],
      fornecedor: [],
      tags: [],
      destinatario,
      dataDe: null,
      dataAte: null,
      resumoFiltro: ResumoNotaFiscalEntradaEnum.Todos,
      periodoSelecionado: PeriodoNotaFiscalEntradaEnum.DoMes,
    });
    this.pesquisar(true);
  }

  proximaPagina(): void {
    if (!this.ultimaPagina) {
      this.paginaAtual++;
      this.pesquisar(false);
    }
  }

  /** Sem toggle: clicar no card ativo mantém ele ativo, para nunca ficar sem card selecionado. */
  selecionarResumo(resumo: ResumoNotaFiscalEntradaEnum): void {
    this.model.get('resumoFiltro')?.setValue(resumo);
    this.pesquisar(true);
  }

  valorResumo(resumo: ResumoNotaFiscalEntradaEnum): number {
    switch (resumo) {
      case ResumoNotaFiscalEntradaEnum.CapturadasHoje:
        return this.resumo.capturadasHoje || 0;
      case ResumoNotaFiscalEntradaEnum.EmLancamento:
        return this.resumo.emLancamento || 0;
      case ResumoNotaFiscalEntradaEnum.ComDivergencia:
        return this.resumo.comDivergencia || 0;
      case ResumoNotaFiscalEntradaEnum.LancadasMes:
        return this.resumo.lancadasMes || 0;
      default:
        return this.resumo.totalNotas || 0;
    }
  }

  toggleGavetaMobile(): void {
    this.isMobileDrawerOpen = !this.isMobileDrawerOpen;
  }
  fecharGavetaMobile(): void {
    this.isMobileDrawerOpen = false;
  }

  selecionarPeriodo(periodo: PeriodoNotaFiscalEntradaEnum, event: Event): void {
    this.model.get('periodoSelecionado')?.setValue(periodo);
    if (periodo === PeriodoNotaFiscalEntradaEnum.DoIntervalo) {
      event.stopPropagation();
      return;
    }
    this.pesquisar(true);
  }

  aplicarIntervalo(trigger: MatMenuTrigger): void {
    const value = this.model.getRawValue();
    if (!value.dataDe || !value.dataAte) {
      this.alertService.show(
        'Aviso',
        'Informe a data inicial e a data final do intervalo.',
        AlertType.warning
      );
      return;
    }
    trigger.closeMenu();
    this.pesquisar(true);
  }

  cancelarIntervalo(trigger: MatMenuTrigger): void {
    this.model.patchValue({
      periodoSelecionado: PeriodoNotaFiscalEntradaEnum.DoMes,
      dataDe: null,
      dataAte: null,
    });
    trigger.closeMenu();
  }

  onDateInput(event: Event, controlName: string): void {
    MaskService.onDateInput(event, this.model.get(controlName));
  }

  prepararAcoes(nota: NotaFiscalEntradaListStruct): void {
    this.acoesLinha = acoesNotaFiscalEntrada(
      nota,
      this.podeLancar,
      this.podeExcluirEstoque,
      this.podeExcluirFinanceiro,
      this.podeManifestar,
      this.authService.getUserInfos().idEmpresa
    );
  }

  executarAcao(acao: AcaoNotaFiscalEntradaStruct, nota: NotaFiscalEntradaListStruct): void {
    switch (acao.acao) {
      case AcaoNotaFiscalEntradaEnum.Editar:
      case AcaoNotaFiscalEntradaEnum.TratarNota:
        this.router.navigate(['/suprimentos/nota-fiscal-entrada/documento', nota.idNFeEntrada]);
        return;
      case AcaoNotaFiscalEntradaEnum.ContinuarAssociacaoItens:
        this.abrirAssociacaoItens(nota);
        return;
      case AcaoNotaFiscalEntradaEnum.Visualizar:
        this.router.navigate(['/suprimentos/nota-fiscal-entrada/documento', nota.idNFeEntrada], {
          queryParams: { modo: 'visualizar' },
        });
        return;
      case AcaoNotaFiscalEntradaEnum.CopiarChaveAcesso:
        navigator.clipboard?.writeText(nota.chaveAcesso ?? '');
        this.alertService.show('Sucesso', 'Chave de acesso copiada.', AlertType.success);
        return;
      case AcaoNotaFiscalEntradaEnum.Marcadores:
        this.alterarTags([nota]);
        return;
      case AcaoNotaFiscalEntradaEnum.ExcluirNota:
        this.excluirNotas([nota]);
        return;
      case AcaoNotaFiscalEntradaEnum.LancarEstoque:
        this.lancarEstoque(nota);
        return;
      case AcaoNotaFiscalEntradaEnum.ExcluirEstoque:
        this.excluirEstoque(nota);
        return;
      case AcaoNotaFiscalEntradaEnum.LancarFinanceiro:
        this.lancarFinanceiro(nota);
        return;
      case AcaoNotaFiscalEntradaEnum.ExcluirFinanceiro:
        this.excluirFinanceiro(nota);
        return;
      case AcaoNotaFiscalEntradaEnum.ReabrirParaEdicao:
        this.reabrirParaEdicao(nota);
        return;
      case AcaoNotaFiscalEntradaEnum.FormacaoPrecos:
        this.abrirFormacaoPrecos(nota);
        return;
      case AcaoNotaFiscalEntradaEnum.RegistrarCiencia:
        this.registrarCiencia(nota);
        return;
      case AcaoNotaFiscalEntradaEnum.Manifestar:
        this.manifestar(nota);
        return;
      case AcaoNotaFiscalEntradaEnum.ConsultarXml:
        this.consultarXml(nota);
        return;
      case AcaoNotaFiscalEntradaEnum.BaixarXml:
        this.baixarXml(nota);
        return;
      case AcaoNotaFiscalEntradaEnum.VerDanfe:
        this.verDanfe(nota);
        return;
      case AcaoNotaFiscalEntradaEnum.VerHistorico:
        this.verHistorico(nota);
        return;
    }
  }

  private verHistorico(nota: NotaFiscalEntradaListStruct): void {
    const data = new HistoricoNotaFiscalEntradaDialogData();
    data.idNFeEntrada = nota.idNFeEntrada;
    data.titulo = `NF-e ${nota.numero || '-'}${nota.serie ? ` / ${nota.serie}` : ''}`;
    this.dialog.open(HistoricoNotaFiscalEntradaDialogComponent, {
      width: '640px',
      maxWidth: '96vw',
      autoFocus: false,
      data,
    });
  }

  /** Ciência da emissão: a SEFAZ libera o XML completo depois dela. */
  private registrarCiencia(nota: NotaFiscalEntradaListStruct): void {
    const ciencia = EVENTOS_MANIFESTACAO_NFE.find(x => x.idTipoEvento === TipoEventoNFeEnum.CienciaEmissao)!;
    this.dialog.open(ConfirmModalComponent, {
      width: '500px',
      data: {
        title: ciencia.titulo,
        description: `${ciencia.descricao} Chave: ${nota.chaveAcesso ?? ''}`,
        buttonConfirm: 'Registrar ciência',
        buttonClose: 'Cancelar',
      },
    }).afterClosed().subscribe(result => {
      if (result?.confirm) this.enviarManifestacao(nota, TipoEventoNFeEnum.CienciaEmissao, null);
    });
  }

  private manifestar(nota: NotaFiscalEntradaListStruct): void {
    const data = new ManifestarNotaFiscalEntradaDialogData();
    data.numeroNota = this.nota(nota);
    data.idTipoEventoManifestacaoAtual = nota.idTipoEventoManifestacaoAtual;
    this.dialog.open(ManifestarNotaFiscalEntradaDialogComponent, {
      width: '560px',
      maxWidth: '95vw',
      disableClose: true,
      data,
    }).afterClosed().subscribe((result?: ManifestarNotaFiscalEntradaDialogResult) => {
      if (result) this.enviarManifestacao(nota, result.idTipoEvento, result.justificativa);
    });
  }

  /** O evento vai para a SEFAZ pelo OrquestradorDFe e o status da nota é atualizado depois, pelos eventos recebidos. */
  private enviarManifestacao(
    nota: NotaFiscalEntradaListStruct,
    idTipoEvento: TipoEventoNFeEnum,
    justificativa: string | null
  ): void {
    if (!nota.idNFeRecebido) {
      this.alertService.show('Aviso', 'NF-e recebida da SEFAZ não encontrada para esta nota.', AlertType.warning);
      return;
    }
    const request = new PostManifestacaoRequest();
    request.idDFeRecebido = nota.idNFeRecebido;
    request.idEmpresaAlvo = nota.idEmpresa;
    request.idModeloDocumento = ModeloDocumentoEnum.NFe;
    request.idTipoEvento = idTipoEvento;
    request.origemDocumentoFiscalRecebido = OrigemDocumentoFiscalRecebidoEnum.EstruturaNova;
    request.justificativa = justificativa;
    this.idNFeEntradaEmAcao = nota.idNFeEntrada;
    this.postManifestacaoService.postManifestacao(request).subscribe({
      next: response => {
        this.idNFeEntradaEmAcao = null;
        if (response.isError) {
          this.alertService.show('Atenção', response.errorDescription, AlertType.warning);
          return;
        }
        this.alertService.show(
          'Sucesso',
          idTipoEvento === TipoEventoNFeEnum.CienciaEmissao
            ? 'Ciência registrada. O status da nota é atualizado na Central assim que o evento for processado.'
            : 'Manifestação registrada. O status da nota é atualizado na Central assim que o evento for processado.',
          AlertType.success
        );
        this.pesquisar(true);
      },
      error: () => {
        this.idNFeEntradaEmAcao = null;
        this.alertService.show('Erro', 'Não foi possível registrar a manifestação na SEFAZ.', AlertType.error);
      },
    });
  }

  /** Distribuição DF-e por chave: o XML devolvido é processado depois pelo worker e completa a nota na Central. */
  private consultarXml(nota: NotaFiscalEntradaListStruct): void {
    const request = new ConsultaChaveNFeRequest();
    request.chaveAcesso = nota.chaveAcesso ?? '';
    request.idEmpresaAlvo = nota.idEmpresa;
    this.idNFeEntradaEmAcao = nota.idNFeEntrada;
    this.consultaChaveNFeService.consultar(request).subscribe({
      next: response => {
        this.idNFeEntradaEmAcao = null;
        if (response.isError) {
          this.alertService.show('Atenção', response.errorDescription, AlertType.warning);
          return;
        }
        if (response.isProcessamentoPendente) {
          this.alertService.show(
            'Sucesso',
            'A SEFAZ devolveu o XML. A nota é completada na Central assim que o processamento terminar.',
            AlertType.success
          );
          return;
        }
        this.alertService.show(
          'Aviso',
          `A SEFAZ não devolveu o XML da nota: ${response.mensagemRetornoSefaz ?? 'sem retorno.'}`,
          AlertType.warning
        );
      },
      error: () => {
        this.idNFeEntradaEmAcao = null;
        this.alertService.show('Erro', 'Não foi possível consultar o XML na SEFAZ.', AlertType.error);
      },
    });
  }

  private baixarXml(nota: NotaFiscalEntradaListStruct): void {
    this.idNFeEntradaEmAcao = nota.idNFeEntrada;
    this.notaFiscalEntradaService.obterXml(nota.idNFeEntrada).subscribe({
      next: response => {
        this.idNFeEntradaEmAcao = null;
        if (response.isError) {
          this.alertService.show('Atenção', response.errorDescription, AlertType.warning);
          return;
        }
        const link = document.createElement('a');
        link.href = URL.createObjectURL(new Blob([response.xml], { type: 'application/xml' }));
        link.download = response.nomeArquivo;
        link.click();
        URL.revokeObjectURL(link.href);
      },
      error: () => {
        this.idNFeEntradaEmAcao = null;
        this.alertService.show('Erro', 'Não foi possível baixar o XML da nota.', AlertType.error);
      },
    });
  }

  /** Gera o DANFE pelo XML da nota no Report; em erro, o Report devolve o ReturnStruct em JSON no lugar do PDF. */
  private verDanfe(nota: NotaFiscalEntradaListStruct): void {
    this.idNFeEntradaEmAcao = nota.idNFeEntrada;
    this.notaFiscalEntradaService.obterXml(nota.idNFeEntrada).subscribe({
      next: xmlResponse => {
        if (xmlResponse.isError) {
          this.idNFeEntradaEmAcao = null;
          this.alertService.show('Atenção', xmlResponse.errorDescription, AlertType.warning);
          return;
        }
        const request = new GerarPdfPorXmlRequest();
        request.xml = xmlResponse.xml;
        this.danfeService.gerarPdfPorXml(request).subscribe({
          next: async pdfBlob => {
            this.idNFeEntradaEmAcao = null;
            if (pdfBlob.type === 'application/pdf') {
              const pdfUrl = URL.createObjectURL(pdfBlob);
              window.open(pdfUrl, '_blank');
              URL.revokeObjectURL(pdfUrl);
              return;
            }
            const erro: ReturnStruct | null = pdfBlob.type === 'application/json'
              ? JSON.parse(await pdfBlob.text())
              : null;
            this.alertService.show(
              'Atenção',
              erro?.errorDescription || 'Não foi possível gerar o DANFE da nota.',
              AlertType.warning
            );
          },
          error: () => {
            this.idNFeEntradaEmAcao = null;
            this.alertService.show('Erro', 'Não foi possível gerar o DANFE da nota.', AlertType.error);
          },
        });
      },
      error: () => {
        this.idNFeEntradaEmAcao = null;
        this.alertService.show('Erro', 'Não foi possível obter o XML da nota.', AlertType.error);
      },
    });
  }

  private abrirFormacaoPrecos(nota: NotaFiscalEntradaListStruct): void {
    const data = new FormacaoPrecosNotaFiscalEntradaDialogData();
    data.idNFeEntrada = nota.idNFeEntrada;
    data.numeroNota = this.nota(nota);
    data.nomeFornecedor = this.fornecedor(nota);
    this.dialog.open(FormacaoPrecosNotaFiscalEntradaDialogComponent, {
      width: '1240px',
      maxWidth: '96vw',
      maxHeight: '94vh',
      disableClose: true,
      data,
    }).afterClosed().subscribe((isAtualizado?: boolean) => {
      if (isAtualizado) this.pesquisar(true);
    });
  }

  incluirNotaFiscal(): void {
    this.router.navigate(['/suprimentos/nota-fiscal-entrada/documento']);
  }

  /** Assistente compartilhado: importa a NF-e e oferece a associação como etapa independente. */
  importarXml(): void {
    const data = new ImportarXmlNotaFiscalEntradaDialogData();
    data.origem = OrigemImportacaoXmlNFeEntradaEnum.CentralNotas;
    const dialogRef = this.dialog.open(ImportarXmlNotaFiscalEntradaDialogComponent, {
      width: '960px',
      maxWidth: '96vw',
      maxHeight: '92vh',
      minHeight: '640px',
      panelClass: 'importar-xml-nota-fiscal-entrada-dialog',
      data,
    });
    dialogRef.afterClosed().subscribe(result => {
      if (!result?.idNFeEntrada) return;
      if (result.acao === 'irParaNota') {
        const url = this.router.serializeUrl(this.router.createUrlTree([
          '/suprimentos/nota-fiscal-entrada/documento', result.idNFeEntrada,
        ]));
        window.open(url, '_blank', 'noopener');
        return;
      }
      if (result.acao === 'associarItens') {
        this.abrirAssociacaoItensPorId(result.idNFeEntrada, result.ordemRegras, result.consideraApenasDescricao);
        return;
      }
      this.dialog.open(ConfirmModalComponent, {
        data: {
          title: 'Associar itens agora?',
          description: 'A NF-e foi importada e ficou Em lançamento. Você pode associar os itens agora ou continuar depois pela Central de NFs.',
          buttonConfirm: 'Associar agora',
          buttonClose: 'Deixar para depois',
        },
      }).afterClosed().subscribe(confirmacao => {
        this.pesquisar(true);
        if (!confirmacao?.confirm) return;
        this.abrirAssociacaoItensPorId(result.idNFeEntrada, result.ordemRegras, result.consideraApenasDescricao);
      });
    });
  }

  private abrirAssociacaoItensPorId(
    idNFeEntrada: number,
    ordemRegras: RegraCorrespondenciaProdutoNFeEntradaEnum[] | null = null,
    considerarApenasDescricao = false,
  ): void {
    const data = new NotaFiscalEntradaAssociacaoDialogData();
    data.idNFeEntrada = idNFeEntrada;
    data.origem = OrigemAssociacaoItensNFeEntradaEnum.CentralNotas;
    data.ordemRegras = ordemRegras;
    data.considerarApenasDescricao = considerarApenasDescricao;
    this.dialog.open(NotaFiscalEntradaAssociacaoDialogComponent, {
      width: '100vw', height: '100vh', maxWidth: '100vw', maxHeight: '100vh',
      disableClose: true, autoFocus: false, data, panelClass: 'nota-fiscal-entrada-associacao-dialog',
    }).afterClosed().subscribe(() => this.pesquisar(true));
  }

  private abrirAssociacaoItens(nota: NotaFiscalEntradaListStruct): void {
    this.abrirAssociacaoItensPorId(nota.idNFeEntrada);
  }

  private lancarEstoque(nota: NotaFiscalEntradaListStruct): void {
    const dialogRef = this.dialog.open(ConfirmModalComponent, {
      data: {
        title: 'Lançar estoque',
        description: `Deseja lançar no estoque os itens da nota ${this.nota(nota)}?`,
        buttonConfirm: 'Lançar estoque',
        buttonClose: 'Cancelar',
      },
    });
    dialogRef.afterClosed().subscribe(result => {
      if (!result?.confirm) return;
      this.idNFeEntradaEmAcao = nota.idNFeEntrada;
      this.notaFiscalEntradaService.lancarEstoque(nota.idNFeEntrada).subscribe({
        next: response => {
          this.idNFeEntradaEmAcao = null;
          if (response.isError) {
            this.alertService.show('Atenção', response.errorDescription, AlertType.warning);
            this.pesquisar(true);
            return;
          }
          this.alertService.show('Sucesso', 'Estoque lançado com sucesso.', AlertType.success);
          if (response.avisoDescricao) this.alertService.show('Atenção', response.avisoDescricao, AlertType.warning);
          this.pesquisar(true);
        },
        error: () => {
          this.idNFeEntradaEmAcao = null;
          this.alertService.show('Erro', 'Não foi possível lançar o estoque.', AlertType.error);
          this.pesquisar(true);
        },
      });
    });
  }

  private excluirEstoque(nota: NotaFiscalEntradaListStruct): void {
    const data = new ExcluirEstoqueNotaFiscalEntradaDialogData();
    data.numeroNota = this.nota(nota);
    const dialogRef = this.dialog.open(ExcluirEstoqueNotaFiscalEntradaDialogComponent, {
      width: '560px',
      maxWidth: '95vw',
      disableClose: true,
      data,
    });
    dialogRef.afterClosed().subscribe((justificativa?: string) => {
      if (!justificativa) return;
      const request = new NFeEntradaEstoqueExcluirRequest();
      request.justificativa = justificativa;
      this.idNFeEntradaEmAcao = nota.idNFeEntrada;
      this.notaFiscalEntradaService.excluirEstoque(nota.idNFeEntrada, request).subscribe({
        next: response => {
          this.idNFeEntradaEmAcao = null;
          if (response.isError) {
            this.alertService.show('Atenção', response.errorDescription, AlertType.warning);
            this.pesquisar(true);
            return;
          }
          this.alertService.show('Sucesso', 'Estoque excluído com sucesso.', AlertType.success);
          if (response.avisoDescricao) this.alertService.show('Atenção', response.avisoDescricao, AlertType.warning);
          this.pesquisar(true);
        },
        error: () => {
          this.idNFeEntradaEmAcao = null;
          this.alertService.show('Erro', 'Não foi possível excluir o estoque.', AlertType.error);
          this.pesquisar(true);
        },
      });
    });
  }

  private lancarFinanceiro(nota: NotaFiscalEntradaListStruct): void {
    const dialogRef = this.dialog.open(ConfirmModalComponent, {
      data: {
        title: 'Lançar financeiro',
        description: `Deseja lançar o financeiro da nota ${this.nota(nota)}?`,
        buttonConfirm: 'Lançar financeiro',
        buttonClose: 'Cancelar',
      },
    });
    dialogRef.afterClosed().subscribe(result => {
      if (!result?.confirm) return;
      this.idNFeEntradaEmAcao = nota.idNFeEntrada;
      this.notaFiscalEntradaService.lancarFinanceiro(nota.idNFeEntrada).subscribe({
        next: response => {
          this.idNFeEntradaEmAcao = null;
          if (response.isError) {
            this.alertService.show('Atenção', response.errorDescription, AlertType.warning);
          } else {
            this.alertService.show('Sucesso', 'Financeiro lançado com sucesso.', AlertType.success);
            if (response.avisoDescricao) this.alertService.show('Atenção', response.avisoDescricao, AlertType.warning);
          }
          this.pesquisar(true);
        },
        error: () => {
          this.idNFeEntradaEmAcao = null;
          this.alertService.show('Erro', 'Não foi possível lançar o financeiro.', AlertType.error);
          this.pesquisar(true);
        },
      });
    });
  }

  private excluirFinanceiro(nota: NotaFiscalEntradaListStruct): void {
    const dialogRef = this.dialog.open(ExcluirFinanceiroNotaFiscalEntradaDialogComponent, {
      width: '560px',
      maxWidth: '95vw',
      disableClose: true,
      data: { numeroNota: this.nota(nota) },
    });
    dialogRef.afterClosed().subscribe((justificativa?: string) => {
      if (!justificativa) return;
      const request = new NFeEntradaFinanceiroExcluirRequest();
      request.justificativa = justificativa;
      this.idNFeEntradaEmAcao = nota.idNFeEntrada;
      this.notaFiscalEntradaService.excluirFinanceiro(nota.idNFeEntrada, request).subscribe({
        next: response => {
          this.idNFeEntradaEmAcao = null;
          if (response.isError) {
            this.alertService.show('Atenção', response.errorDescription, AlertType.warning);
          } else {
            this.alertService.show('Sucesso', 'Financeiro excluído com sucesso.', AlertType.success);
            if (response.avisoDescricao) this.alertService.show('Atenção', response.avisoDescricao, AlertType.warning);
          }
          this.pesquisar(true);
        },
        error: () => {
          this.idNFeEntradaEmAcao = null;
          this.alertService.show('Erro', 'Não foi possível excluir o financeiro.', AlertType.error);
          this.pesquisar(true);
        },
      });
    });
  }

  /** Lançada volta para Em lançamento com a justificativa no histórico (Story, seção 12.1). */
  private reabrirParaEdicao(nota: NotaFiscalEntradaListStruct): void {
    const data = new ReabrirNotaFiscalEntradaDialogData();
    data.numeroNota = this.nota(nota);
    const dialogRef = this.dialog.open(ReabrirNotaFiscalEntradaDialogComponent, {
      width: '560px',
      maxWidth: '95vw',
      disableClose: true,
      data,
    });
    dialogRef.afterClosed().subscribe((justificativa?: string) => {
      if (!justificativa) return;
      const request = new NFeEntradaReabrirRequest();
      request.justificativa = justificativa;
      this.idNFeEntradaEmAcao = nota.idNFeEntrada;
      this.notaFiscalEntradaService.reabrir(nota.idNFeEntrada, request).subscribe({
        next: response => {
          this.idNFeEntradaEmAcao = null;
          if (response.isError) {
            this.alertService.show('Atenção', response.errorDescription, AlertType.warning);
          } else {
            this.alertService.show('Sucesso', 'Nota reaberta para edição.', AlertType.success);
          }
          this.pesquisar(true);
        },
        error: () => {
          this.idNFeEntradaEmAcao = null;
          this.alertService.show('Erro', 'Não foi possível reabrir a nota.', AlertType.error);
          this.pesquisar(true);
        },
      });
    });
  }

  public excluirNotas(notas: NotaFiscalEntradaListStruct[] = this.selection.selected): void {
    if (!notas.length) return;

    // Estoque ou financeiro lançado trava a exclusão.
    const notaComEfeitoGerado = notas.some(nota => nota.isEstoqueLancado || nota.isFinanceiroLancado);
    const notaCancelada = notas.some(nota => nota.isCancelada);
    const notaLancada = notas.some(nota => nota.idStatusNFeEntrada === StatusNFeEntradaEnum.Lancada);
    if (notaComEfeitoGerado || notaCancelada || notaLancada) {
      this.alertService.show(
        'Aviso',
        notaCancelada
          ? 'Notas canceladas pelo emitente não podem ser excluídas.'
          : notaComEfeitoGerado
            ? 'Exclua o estoque e o financeiro lançados antes de excluir a nota.'
            : 'Reabra a nota para edição antes de excluir.',
        AlertType.warning
      );
      return;
    }

    const isEmLote = notas.length > 1;
    const dialogRef = this.dialog.open(ConfirmModalComponent, {
      data: {
        title: isEmLote ? 'Excluir notas fiscais de entrada' : 'Excluir nota fiscal de entrada',
        description: isEmLote
          ? `Deseja excluir as ${notas.length} notas fiscais de entrada selecionadas?`
          : `Deseja excluir a nota fiscal de entrada ${this.nota(notas[0])}?`,
        buttonConfirm: 'Excluir',
        buttonClose: 'Cancelar',
      },
    });

    dialogRef.afterClosed().subscribe(result => {
      if (!result?.confirm) return;

      if (!isEmLote) this.idNFeEntradaEmAcao = notas[0].idNFeEntrada;
      const requisicao = isEmLote
        ? this.nfeEntradaService.excluirEmLote(notas.map(nota => nota.idNFeEntrada))
        : this.nfeEntradaService.excluir(notas[0].idNFeEntrada);
      requisicao.pipe(finalize(() => this.idNFeEntradaEmAcao = null)).subscribe({
        next: response => {
          if (response.isError) {
            this.alertService.show('Atenção', response.errorDescription, AlertType.warning);
            return;
          }
          this.alertService.show(
            'Sucesso',
            isEmLote ? 'Notas fiscais excluídas com sucesso.' : 'Nota fiscal excluída com sucesso.',
            AlertType.success
          );
          this.selection.clear();
          this.pesquisar(true);
        },
        error: () =>
          this.alertService.show(
            'Erro',
            'Não foi possível excluir a nota fiscal de entrada.',
            AlertType.error
          ),
      });
    });
  }

  public alterarTags(notas: NotaFiscalEntradaListStruct[] = this.selection.selected): void {
    if (!notas.length) return;
    if (notas.some(nota => nota.idEmpresa !== this.authService.getUserInfos().idEmpresa)) {
      this.alertService.show(
        'Aviso',
        'As tags só podem ser alteradas para notas da empresa atual.',
        AlertType.warning
      );
      return;
    }
    const idsTagsAtuais = notas
      .map(nota => new Set((nota.tags || []).map(tag => tag.idTagNFeEntrada)))
      .reduce((comuns, atuais) => new Set([...comuns].filter(id => atuais.has(id))));
    const dialogRef = this.dialog.open(AlterarTagsNotaFiscalEntradaDialogComponent, {
      width: '480px',
      maxWidth: '95vw',
      maxHeight: '90vh',
      disableClose: true,
      data: {
        idsNFeEntrada: notas.map(nota => nota.idNFeEntrada),
        tags: this.listaTags,
        idsTagsAtuais: [...idsTagsAtuais],
      } as AlterarTagsNotaFiscalEntradaDialogData,
    });
    dialogRef.afterClosed().subscribe(atualizou => {
      if (atualizou) this.pesquisar(true);
    });
  }

  public exportar(notas: NotaFiscalEntradaListStruct[] | null = null): void {
    const value = this.model.getRawValue();
    const { dataDe, dataAte } = this.getPeriodo();
    const filtros: FiltroExtracao[] = [];
    filtros.push({
      label: 'Resumo da listagem',
      formControlName: 'idResumoFiltro',
      valor: this.resumoFiltro,
      valorExibicao: this.opcaoResumoAtual.rotulo,
    });
    if (dataDe)
      filtros.push({
        label: 'Data inicial',
        formControlName: 'dataDe',
        valor: formatDate(dataDe, 'yyyy-MM-dd', 'pt-BR'),
        valorExibicao: this.formatarDataParaExtracao(dataDe),
      });
    if (dataAte)
      filtros.push({
        label: 'Data final',
        formControlName: 'dataAte',
        valor: formatDate(dataAte, 'yyyy-MM-dd', 'pt-BR'),
        valorExibicao: this.formatarDataParaExtracao(dataAte),
      });
    if (value.pesquisa)
      filtros.push({ label: 'Pesquisa', formControlName: 'pesquisar', valor: value.pesquisa });
    if (value.status?.length)
      filtros.push({
        label: 'Status',
        formControlName: 'listIdStatusNFeEntrada',
        valor: value.status,
        valorExibicao: this.nomesLookup(value.status, this.listaStatus),
      });
    if (value.origem?.length)
      filtros.push({
        label: 'Origem',
        formControlName: 'listIdOrigemNFeEntrada',
        valor: value.origem,
        valorExibicao: this.nomesLookup(value.origem, this.listaOrigem),
      });
    if (value.fornecedor?.length)
      filtros.push({
        label: 'Fornecedor',
        formControlName: 'listIdPessoaEmitente',
        valor: value.fornecedor,
        valorExibicao: value.fornecedor.map(id => this.fornecedores.get(id) ?? String(id)),
      });
    if (value.tags?.length)
      filtros.push({
        label: 'Tags',
        formControlName: 'listIdTagNFeEntrada',
        valor: value.tags,
        valorExibicao: value.tags.map(
          id => this.listaTags.find(tag => tag.idTagNFeEntrada === id)?.descricao ?? String(id)
        ),
      });
    if (value.destinatario?.length)
      filtros.push({
        label: 'Destinatário',
        formControlName: 'listIdEmpresa',
        valor: value.destinatario,
        valorExibicao: value.destinatario.map(
          id => this.listaEmpresas.find(empresa => empresa.idEmpresa === id)?.nomeEmpresa ?? String(id)
        ),
      });
    if (notas?.length)
      filtros.push({
        label: 'Notas selecionadas',
        formControlName: 'idsNFeEntrada',
        valor: notas.map(nota => nota.idNFeEntrada),
        valorExibicao: notas.map(nota => this.nota(nota)),
      });

    this.dialog.open(ExtracaoDadosModalComponent, {
      data: {
        titulo: 'Exportar notas fiscais de entrada',
        tipoExtracao: TipoExtracaoEnum.NotasFiscaisEntradaCSV,
        origemPedidoExportacao: OrigemPedidoExportacaoEnum.SuprimentosNotasFiscaisEntrada,
        filtros,
        possuiAutomacao: false,
      } as ExtracaoDadosData,
      panelClass: 'extracao-dados-panel',
      width: '640px',
      maxWidth: '96vw',
      disableClose: true,
    });
  }

  fornecedor(nota: NotaFiscalEntradaListStruct): string {
    return nota.idPessoaEmitente
      ? this.fornecedores.get(nota.idPessoaEmitente) || ''
      : 'Fornecedor a definir';
  }
  destinatario(nota: NotaFiscalEntradaListStruct): string {
    return this.listaEmpresas.find(x => x.idEmpresa === nota.idEmpresa)?.nomeEmpresa ?? '—';
  }
  nota(nota: NotaFiscalEntradaListStruct): string {
    return `${nota.numero || '—'}${nota.serie ? ` / ${nota.serie}` : ''}`;
  }
  status(nota: NotaFiscalEntradaListStruct): string {
    return this.listaStatus.find(x => x.id === nota.idStatusNFeEntrada)?.nome || '—';
  }
  origem(nota: NotaFiscalEntradaListStruct): string {
    return this.listaOrigem.find(x => x.id === nota.idOrigemNFeEntrada)?.nome || '—';
  }
  temManifestacao(nota: NotaFiscalEntradaListStruct): boolean {
    return nota.idOrigemNFeEntrada === this.origemEnum.Sefaz;
  }
  manifestacao(nota: NotaFiscalEntradaListStruct): string {
    return nota.isManifestacaoConclusivaNaoIdentificada
      ? 'Conclusiva não identificada'
      : rotuloManifestacao(nota.idTipoEventoManifestacaoAtual);
  }
  classeBadgeManifestacao(nota: NotaFiscalEntradaListStruct): string {
    return classeBadgeManifestacao(nota.idTipoEventoManifestacaoAtual);
  }
  iconeStatus(nota: NotaFiscalEntradaListStruct): string {
    return iconeStatusNFeEntrada(nota.idStatusNFeEntrada);
  }
  iconeOrigem(nota: NotaFiscalEntradaListStruct): string {
    return iconeOrigemNFeEntrada(nota.idOrigemNFeEntrada);
  }
  /** Indicadores da coluna Integrações: o vínculo C e depois as letras na ordem fixa (E, F), só quando lançadas. */
  integracoes(nota: NotaFiscalEntradaListStruct): { sigla: string; rotulo: string; cor: string }[] {
    const indicadores: { sigla: string; rotulo: string; cor: string }[] = [];
    if (nota.isVinculadaPedidoCompra) {
      indicadores.push({ sigla: 'C', rotulo: 'Vinculada a pedido de compra', cor: 'var(--indicador-cor-c)' });
    }
    if (nota.isEstoqueLancado) {
      const estoque = TipoIntegracaoIndicador[TipoIntegracaoEnum.Estoque];
      indicadores.push({ sigla: estoque.sigla, rotulo: 'Estoque lançado', cor: estoque.cor });
    }
    if (nota.isFinanceiroLancado) {
      const financeiro = TipoIntegracaoIndicador[TipoIntegracaoEnum.Financeiro];
      indicadores.push({ sigla: financeiro.sigla, rotulo: 'Financeiro lançado', cor: financeiro.cor });
    }
    return indicadores;
  }

  /** Monta um badge único no fluxo normal e preserva cada pedido se as etapas divergirem. */
  etapasPedidos(nota: NotaFiscalEntradaListStruct): EtapaPedidoBadgeView[] {
    const pedidos = nota.pedidosVinculados ?? [];
    if (!pedidos.length) return [];

    const chaveEtapa = (pedido: typeof pedidos[number]) =>
      pedido.idEtapaKanban?.toString() ?? `sem-etapa:${pedido.chaveEtapa ?? ''}`;
    const etapasDistintas = new Set(pedidos.map(chaveEtapa));
    if (etapasDistintas.size === 1) {
      const etapa = pedidos[0];
      return [{
        key: chaveEtapa(etapa),
        nome: etapa.nomeEtapa || 'Etapa não identificada',
        cor: this.corEtapaPedido(etapa.corEtapa),
        icone: etapa.iconeEtapa || 'view_kanban',
        tooltip: `Pedidos: ${pedidos.map(x => x.codigoCompra).join(', ')}`,
      }];
    }

    return pedidos.map(pedido => ({
      key: `${pedido.idCompra}:${chaveEtapa(pedido)}`,
      nome: pedido.nomeEtapa || 'Etapa não identificada',
      cor: this.corEtapaPedido(pedido.corEtapa),
      icone: pedido.iconeEtapa || 'view_kanban',
      tooltip: `Pedido ${pedido.codigoCompra}: ${pedido.nomeEtapa || 'etapa não identificada'}`,
    }));
  }

  /** Indicador "Pedido com divergência": vem da etapa do pedido no processo de compras, não da conferência da nota. */
  temPedidoComDivergencia(nota: NotaFiscalEntradaListStruct): boolean {
    return pedidosComDivergencia(nota.pedidosVinculados).length > 0;
  }

  tooltipPedidoComDivergencia(nota: NotaFiscalEntradaListStruct): string {
    return tooltipPedidosComDivergencia(pedidosComDivergencia(nota.pedidosVinculados));
  }

  private corEtapaPedido(cor: string | null): string {
    return /^#[0-9a-f]{6}$/i.test(cor ?? '') ? cor! : '#64748b';
  }
  classeBadgeStatus(nota: NotaFiscalEntradaListStruct): string {
    return classeBadgeStatusNFeEntrada(nota.idStatusNFeEntrada);
  }
  subStatus(nota: NotaFiscalEntradaListStruct): string {
    if (nota.idStatusNFeEntrada === StatusNFeEntradaEnum.CapturadaSefaz)
      return rotuloDisponibilidadeDocumentoSefaz(nota.idDisponibilidadeDocumentoSefaz);
    if (nota.idStatusNFeEntrada === StatusNFeEntradaEnum.EmLancamento && nota.possuiAssociacaoPendente)
      return 'Associação de itens pendente';
    return '';
  }
  tooltipSubStatus(nota: NotaFiscalEntradaListStruct): string {
    return nota.idStatusNFeEntrada === StatusNFeEntradaEnum.CapturadaSefaz
      ? descricaoDisponibilidadeDocumentoSefaz(nota.idDisponibilidadeDocumentoSefaz)
      : 'A nota fica em lançamento até que os itens sejam associados e as divergências bloqueantes resolvidas.';
  }
  isPreXml(nota: NotaFiscalEntradaListStruct): boolean {
    return isStatusParcial(nota.idStatusNFeEntrada, nota.idDisponibilidadeDocumentoSefaz);
  }

  isAllSelected(): boolean {
    return this.selection.selected.length === this.dataSource.data.length;
  }
  toggleAllRows(): void {
    this.isAllSelected() ? this.selection.clear() : this.selection.select(...this.dataSource.data);
  }

  private carregarFornecedores(notas: NotaFiscalEntradaListStruct[]): void {
    const ids = notas
      .map(x => x.idPessoaEmitente)
      .filter((id): id is number => !!id && !this.fornecedores.has(id));
    if (!ids.length) return;
    const request = new ListPessoaIdsRequest();
    request.listIdPessoa = ids;
    this.pessoaLookupService
      .getListPessoaIds(request)
      .subscribe(response =>
        response.listaPessoa?.forEach(pessoa =>
          this.fornecedores.set(pessoa.idPessoa, pessoa.nomeFantasia || pessoa.nome)
        )
      );
  }

  private getPeriodo(): { dataDe: Date; dataAte: Date } {
    const value = this.model.getRawValue();
    if (this.periodoSelecionado === PeriodoNotaFiscalEntradaEnum.DoIntervalo && value.dataDe && value.dataAte)
      return { dataDe: value.dataDe, dataAte: value.dataAte };

    const hoje = new Date();
    const dataDe = new Date(hoje);
    switch (this.periodoSelecionado) {
      case PeriodoNotaFiscalEntradaEnum.Hoje:
        dataDe.setHours(0, 0, 0, 0);
        break;
      case PeriodoNotaFiscalEntradaEnum.DaSemana:
        dataDe.setDate(hoje.getDate() - 6);
        break;
      case PeriodoNotaFiscalEntradaEnum.DoMes:
        dataDe.setDate(1);
        break;
      default:
        dataDe.setDate(hoje.getDate() - 29);
        break;
    }
    return { dataDe, dataAte: hoje };
  }

  private formatarDataParaExtracao(data: Date): string {
    return new Intl.DateTimeFormat('pt-BR').format(data);
  }

  private nomesLookup(ids: number[], opcoes: NotaFiscalEntradaLookupStruct[]): string[] {
    return ids.map(id => opcoes.find(opcao => opcao.id === id)?.nome ?? String(id));
  }

  private getSortValue(row: NotaFiscalEntradaListStruct, property: string): string | number {
    switch (property) {
      case 'nota':
        return this.nota(row);
      case 'emissao':
        return row.dataEmissao ? new Date(row.dataEmissao).getTime() : 0;
      case 'lancamento':
        return row.dataEntradaSaida ? new Date(row.dataEntradaSaida).getTime() : 0;
      case 'destinatario':
        return this.destinatario(row);
      case 'fornecedor':
        return this.fornecedor(row);
      case 'valor':
        return row.valorTotal || 0;
      case 'origem':
        return this.origem(row);
      case 'status':
        return this.status(row);
      default:
        return '';
    }
  }
}
